import { API_BASE } from "../config";

/**
 * Ask the API to email a password reset link. The API answers the same way
 * whether or not the address has an account (PRTL-1387), so success here
 * means only that the request was accepted.
 */
export async function requestResetLink(email: string): Promise<void> {
    const res = await fetch(`${API_BASE}/reset-password/request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || "Failed to send reset link");
    }
}
